export const SHOW_LOADER = 'AppShowLoader'
export const HIDE_LOADER = 'AppHideLoader'

export const SHOW_DRAWER = 'AppShowDrawer'
export const HIDE_DRAWER = 'AppHideDrawer'

export const SHOW_LEFTPANEL = 'AppShowLeftPanel'
export const HIDE_LEFTPANEL = 'AppHideLeftPanel'

export const SHOW_SNACKBAR = 'AppShowSnackbar'
export const HIDE_SNACKBAR = 'AppHideSnackbar'
export const STACK_SNACKBAR = 'AppStackSnackbar'

export const SET_LOADER = 'AppSetLoader'
export const SET_LOADERS = 'AppSetLoaders'